import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Claim } from '@shared/models/claim';
import { ClaimState } from '@shared/models/codebooks/claim-state';
import { ActiveInsuranceGroup } from '@shared/models/active-insurance-group';
import { DataService } from '@core/services/data.service';

@Component({
    selector: 'app-claim-card',
    templateUrl: './claim-card.component.html',
    styleUrls: ['./claim-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ClaimCardComponent implements OnInit {
  @Input() claim: Claim;
  @Input() claimState: ClaimState;

  public downLoadDocumentUrl: string;

  public drawerOpenModel = false;
  public clickedItem = false;

  constructor(
    private dataService: DataService
  ) {
    this.downLoadDocumentUrl = dataService.environmentConfig.downloadDocumentUrl;
  }

  ngOnInit(): void {

  }

  getGroupByLobId(lobId: number): ActiveInsuranceGroup {
    return this.dataService.activeInsuranceGroups.find(group => group.lobIds.some(x => x === lobId));
  }
}
